import { LOCALES } from "../locales";

export default {
  [LOCALES.KOREAN]: {
    // general product translation
    January: "january",
    February: "february",
    March: "march",
    April: "april",
    May: "may",
    June: "june",
    July: "july",
    August: "august",
    September: "september",
    October: "october",
    November: "november",
    December: "december",
    class_policy: "수업 방침",
    Faq: "FAQs",
    help: "Help",
    frequently_asked_ques: "Frequently Asked Questions",
    customer_support: "Customer Support",
    user_name: "User name",
    password: "Password",
    email_address: "Email address",
    // Header Translations
    notification: "Notification",
    page_loading_aria: "Page is loading",
    state_loading_aria: "State is loading",
    city_loading_aria: "City is loading",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Overall badge",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Certificate image",
    certificate_download: "Download certificate button",
    prev: "Previous",
    log_out: "Log out",
    // feature names
    feature_progress: "Progress",
    feature_stressAndIntonation_title: "Stress and intonation",
    feature_soundOfEnglish_title: "Sounds of english",
    feature_vocabularyCenter_title: "Vocabulary center",
    feature_grammarCenter_title: "Grammar center",
    feature_culture_centre_title: "문화센터",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Industry feed",
    feature_newsfeed_title: "News feed",
    feature_emailTemplates_title: "Email templates",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_accentsAndDialects_title: "Accents and dialects",
    feature_writingCenter_title: "Writing center",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "About",
    legal: "Legal",
    privacy_policy: "Privacy policy",
    Terms_conditions: "Terms and conditions",
    //button translations
    button_continue: "계속",
    button_KnowMore: "Know more",
    button_BuyNow: "Buy Now",
    button_Subscribe: "Subscribe",
    button_GetStarted: "Get started",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "View Details",
    button_ContinueStudying: "Continue",
    button_next: "다음",
    button_confirm: "Confirm",
    // cookie policy
    common_cookiesPolicyText1:
      "By continuing to use this site, you agree to the use of cookies to provide you with better services. Read our",
    common_cookiesPolicyText2: "cookies policy",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Welcome",
    login_heloo: "Hello again",
    login_welcome_text: "Let's get started.",
    login_log_in: "Log in",
    login_errorIncorrectCreds: "Username or password incorrect",
    login_errorContactAmin: "Your account is not active. Contact your administrator.",
    login_errorSSOuser: "You must log in from your company's learning portal.",
    login_resetPasswordTitle: "Reset Password",
    login_resetConfirmText: "Confirm",
    login_resetSuccess: "We’ve sent you an email containing a link that will allow you to reset your password.",
    login_resetFailure: "Email Address is incorrect",
    // common translations
    message_errorDefault: "Something went wrong",
    message_successUpdated: "Updated successfully",
    message_unknownError: "Unknown error",
    message_unAuthorized: "You are not authorized to access this page",
    message_passwordUpdated: "Password updated successfully",
    message_profileUpdated: "Profile updated successfully",
    message_welcomeSubmitted: "Submitted successfully",
    message_samepasswordError: "Enter a new password, please make sure its not a previously used one.",
    SAR: "지역 선택",
    SAL: "위치 선택",
    SAT: "주제 선택",
    link_readmore: "Read more",
    //--//
    profile_title: "프로필",
    profile_nameLabel: "이름: ",
    profile_countryLabel: "국가",
    profile_stateLabel: "State / Province / Region",
    profile_cityLabel: "시",
    profile_emailLabel: "Email",
    profile_prefContactLabel: "Preferred contact",
    profile_prefSkypeLabel: "Skype (Personal) ID",
    profile_prefMobileLabel: "Mobile number",
    profile_prefLandlineLabel: "Landline number",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "I accept and agree to the terms and conditions",
    profile_continueAria: "Continue button",
    profile_TermsAria: "accept terms and conditions",
    profile_stateTooltip: "Your timezone will help us to schedule your online sessions",
    profile_cityTooltip: "If you dont live in one of the cities shown here, please pick the one closest to you",
    profile_emailTooltip: "Verify your email",
    profile_prefTooltip:
      "All your sessions will take place in the virtual classroom, even if you specified a different contact method in the on-boarding process. We ask you about your preferred contact method for internal use only so that we can continually improve your learning experience.",
    profile_fnamePlaceholder: "이름",
    profile_lnamePlaceholder: "성",
    profile_countryPlaceholder: "국가 선택",
    profile_prefContactSelect: "Select your preference",
    profile_statePlaceholder: "Select a state",
    profile_cityPlaceholder: "Select a city",
    profile_emailInvalidMessage: "Email Address is invalid",
    profile_prefContactPlaceholder: "Choose your preference",
    profile_prefSkypePlaceholder: "Skype (Personal)",
    profile_emailVerifiedChip: "Verified",
    profile_emailVerifyChip: "Verify",
    profile_emailpopup_head: "Enter verification code",
    profile_emailpopup_resendText: "Resend code",
    profile_emailpopup_resendMessage: "Didn't receive the code?",
    profile_invalidNumber: "Invalid number",
    profile_prefSkypeAria: "Preferred Contact as Skype (Personal) ID",
    profile_prefMobileAria: "Preferred Contact as Mobile",
    profile_prefLandlineAria: "Preferred Contact as Landline",
    profile_emailpopup_incorrectCode: "Invalid code",
    profile_editLabel: "Edit profile",
    profile_editAria: "Edit button",
    profile_mainPasswordPlaceholder: "Enter password here",
    profile_updateLabel: "업데이트",
    profile_welcomeJumbotron: "어서 오십시오",
    profile_cancelLabel: "취소",
    noAccessl1: "Oops! You don't have permission to view this page!",
    noAccessl2: "Here's a link back to the",
    noAccessl2_1: "homepage",
    noAccessl3: "Please contact your Learnship Administrator for help.",
    profile_license_information: "License information",
    profile_license_message: "라이센스 만료일:",
    profile_changepass_changepassHead: "Change password",
    profile_changepass_currentpassword: "Current password",
    profile_changepass_currentpasswordPlaceholder: "Enter current password",
    profile_changepass_newpassword: "New password",
    profile_changepass_newpasswordPlaceholder: "Enter new password",
    profile_changepass_confirmnewpassword: "Confirm new password",
    profile_passMustInclude: "Your password must include:",
    profile_passdontmatch: "Passwords don't match",
    profile_incorrectPassword: "Incorrect password",
    profile_passwordSubmit_title: "Enter password",
    profile_changepass_conditionLength: "Between 8 to 32 characters",
    profile_changepass_conditionUppercase: "At least one uppercase letter",
    profile_changepass_conditionLowercase: "At least one lowercase letter",
    profile_changepass_conditionSpecialCharacters: "At least one digit or one of these symbols $!#&@?%*_",
    profile_translationLanguage: "번역",
    profile_translationLanguagePlaceholder: "Choose a language",
    profile_managerEmailPlaceholder: "Manager email",
    profile_managerEmailpopupPlaceholder: "Manager’s email address",
    // Learner Home Page translations
    learnerhome_survey_header: "We need your feedback!",
    learnerhome_survey_line1: "Your company wants to know about your experience using our service.",
    learnerhome_survey_line2: "Please complete our survey by",
    learnerhome_survey_line3: "Your feedback is very important and greatly appreciated.",
    learnerhome_survey_button1: "Take survey",
    learnerhome_survey_button2: "Skip survey",
    active_course: "Active course",
    admin_header: "Administration",
    admin_dashboard_header: "Dashboard",
    get_startedText: "Click on a course below to get started.",
    product_solo_desc:
      "Learnship SoloTM, our e-learning product, provides everything learners need to practice and improve their business language skills at their own pace.",
    product_conversationPractice_desc:
      "Learners can book one-on-one sessions with trainers to ask questions, discuss a particular issue or role play scenarios. Useful for more experienced learners looking to finesse their skills.",
    product_sprint_businessSkills_desc:
      "This next-generation blended learning program helps learners develop specific business skills—presenting, negotiating, business writing and meeting participation—in record time.",
    product_sprint_levelsProgress_desc:
      "Our next-generation blended language program helps your people rapidly improve their English language skills against a standardized framework.",
    product_sprint_business_german_desc:
      "Our next-generation blended language program helps your people rapidly improve their German language skills against a standardized framework.",
    product_sprint_business_french_desc:
      "Our next-generation blended language program helps your people rapidly improve their French language skills against a standardized framework.",
    product_sprint_business_spanish_desc:
      "Our next-generation blended language program helps your people rapidly improve their Spanish language skills against a standardized framework.",
    product_evolve_relocationLanguage_desc:
      "Our employee relocation program helps learners develop a deeper understanding of the language and social nuances of their new country of residence.",
    product_evolve_culturePowerSkills_desc:
      "Give your employees the cross-cultural skills they need to thrive in international working environments and global virtual teams.",
    product_evolve_cultureFocus_desc:
      "Country-specific training and cultural-intelligence for learners who need to gain a better understanding of a specific region and its working culture.",
    product_evolve_cultureChange_desc:
      "This is our premier intercultural business training program for expats. It gives learners an in-depth understanding of what it takes to live and work in a new culture.",
    product_elevate_businessSkills_desc:
      "Short, standardized training modules for language learners who want to improve specific business skills such as presenting, negotiating or team leadership. We also offer specialist courses focused on industry-specific dialects.",
    product_elevate_levelsProgress_desc:
      "This trainer-led business language course helps learners improve their written and verbal skills against a standardized framework.",
    product_coach_languageCoach_desc:
      "Communicate confidently and clearly in boardrooms, emails, negotiations and even around the watercooler. Our one-on-one, hyper-specific executive language coaching helps you master the most important business scenarios. Develop your verbal, written, meeting and personal communication skills.",
    product_solo_business_english:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business English at your own pace.",
    product_solo_business_german:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business German at your own pace.",
    product_solo_business_french:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business French at your own pace.",
    product_solo_business_spanish:
      "A multi-level learning program with engaging online exercises to develop your knowledge and application of Business Spanish at your own pace.",
    product_coach_cultureCoach_desc:
      "A hyper-focused, one-on-one coaching program for executives looking to solve specific cross-cultural communication problems.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "This is your gateway to Dashboard - an intuitive interface that allows administrators to track usage, analyze learner progress, optimize programs and evaluate ROI.",
    product_elevate_desc:
      "Elevate Business English is our online, face-to-face language training for learners who want to improve their overall language proficiency working with a personal trainer.",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc:
      "This rich multimedia program helps your people rapidly improve their English language skills against a standardized framework.",
    //feature translations
    feature_cultureCentre_desc:
      "Familiarize yourself with the cultures of the regions that are important to your business and professional life.",
    feature_emailTemplates_desc:
      "Email templates cover a wide variety of business topics. Select the template you want and export it directly to your email client where you can edit it.",
    feature_newsFeed_desc:
      "Welcome to witness a news reading and English learning experience where content and questions are generated live, which gives you access to world news and helps you to enhance your English.",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc:
      "The Industry Feed combines a library of industry-specific articles with AI-powered language exercises. Choose an article along with a grammar point you want to practice…",
    feature_accentsAndDialects_desc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui.",
    feature_accentsAndDialects:
      "Explore the richness of global English usage through our library of regional speech samples.",
    feature_stressAndIntonation_desc:
      "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",
    feature_soundOfEnglish_desc:
      "Improve your communication skills by learning how to pronounce English sounds correctly.",
    feature_vocabularyCenter_desc:
      "Without grammar, very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",
    feature_grammarCenter_desc:
      "The Grammar Center will help you use correct grammar in your speaking and writing. It includes grammar topics, such as basic sentence parts, verbs and verb forms, and sentences and clauses.",
    feature_globalCommunityTutorials_desc:
      "Improve your English language skills with this growing collection of community-developed lessons.",
    feature_toeic_desc:
      "The TOEIC® test is the instrument most widely used by multinational corporations to measure employees’ English proficiency. The TOEIC® uses authentic written materials and dialogue to assess your business English skills.",
    feature_toefl_desc:
      "TOEFL®, the Test of English as a Foreign Language, is used worldwide by colleges and universities, government agencies, and scholarship programs to evaluate English proficiency.",
    feature_businessSituations_desc:
      "The Business Situations Index makes it easy for you to find specific activities so that you can focus on the language you need to communicate in a variety of business situations.",
    //carousel block translations
    title_feature: "Feature",
    we_recommend: "We also recommend",
    // session report translations
    SessionReport_sessionReport: "세션 보고서",
    SessionReport_sessionDetails: "Details",
    SessionReport_teacherName: "Teacher name",
    SessionReport_sessionReview: "Session review",
    SessionReport_sessionFeedback: "Session feedback",
    SessionReport_sessionMaterials_Assignments: "Session Materials & Assignments",
    SessionReport_instructions: "명령",
    SessionReport_open: "열기 위해",
    SessionReport_invalidSession_Message: "Sorry, there is no report for this session",
    SessionReport_rateSession: "세션 평가하기",
    SessionReport_handouts: "Handouts",
    SessionReport_coachName: "세션은 어땠나요",
    SessionRating_sessionDate: "Session date",
    SessionRating_sessionTime: "Session time",
    SessionRating_sessionDuration: "Session duration",
    SessionRating_status: "Status",
    SessionRating_rateYourExperience: "Rate your experience",
    SessionRating_whatWentWrong: "어떤 부분이 잘못되었습니까?",
    SessionRating_content: "내용",
    SessionRating_technology: "기술",
    SessionRating_comment: "코멘트를 남겨주세요",
    SessionRating_submit: "제출",
    SessionRating_remindMeLater: "나중에 알림",
    SessionRating_close: "Close",
    SessionRating_completed: "Finished",
    sessionRating_sessionDetails_mins: "Minutes",
    // my schedule page translations
    myschedule_availability_abty_given: "We are working hard to match you with a trainer",
    myschedule_schedule: "My schedule",
    myschedule_availability_needAvl: "We need your availability to schedule your session",
    myschedule_availability_abty_not_given: "Provide / Modify your availability.",
    myschedule_statusCard_completed: "Session(s) completed",
    myschedule_statusCard_remaining: "Session(s) remaining",
    myschedule_statusCard_scheduled: "Session(s) to be scheduled",
    myschedule_statusCard_lost: "Lost (Late cancelled and absent)",
    myschedule_recentUpcoming_courseName: "Course name",
    myschedule_next_session: "Next session",
    myschedule_session_topic: "Session topic",
    myschedule_sessionDetails_communication: "Communication",
    myschedule_sessionDetails_allSessions: "All sessions",
    myschedule_sessionDetails_upcomingSessions: "Upcoming sessions",
    myschedule_sessionDetails_pastSessions: "Past sessions",
    myschedule_sessionDetails_teacher_name: "Teacher",
    myschedule_sessionDetails_sessions: "Number",
    myschedule_sessionDetails_dateTime: "Date / Time",
    myschedule_sessionDetails_date: "Date",
    myschedule_sessionDetails_time: "Time",
    myschedule_sessionDetails_durationText: "Duration",
    myschedule_sessionDetails_min: "Min",
    myschedule_reschedule_Title: "How to reschedule your session",
    myschedule_reschedule_InstrBegin: "Here's how you can reschedule your sessions with your trainer:",
    myschedule_reschedule_instr1a: "Check session details at the top",
    myschedule_reschedule_instr1b: "The date and time of your session are shown at the top.",
    myschedule_reschedule_instr2: "Trainer’s availability is displayed in green",
    myschedule_reschedule_instr3:
      "You will be able to see your trainer's availability. Available time slots are in green.",
    myschedule_reschedule_instr4: "Select a slot to reschedule",
    myschedule_reschedule_instr5:
      "To reschedule, click into the green area of available time slots for your chosen time.",
    myschedule_reschedule_next_instr1: "No suitable time slot",
    myschedule_reschedule_next_instr2:
      "Try to avoid cancellations, if you really cannot find a suitable time with your trainer, use the 'NO SUITABLE TIME SLOT' button to cancel your session. In this case your trainer will schedule this session for you or an administrator will assist you.",
    myschedule_reschedule_next_instr3: "Change your trainer",
    myschedule_reschedule_next_instr4a:
      "To change your trainer for one or more of your remaining sessions please use our",
    myschedule_reschedule_next_instr4b: "Contact form",
    myschedule_reschedule_next_instr4c:
      " and select {productname} + 'Change Trainer'.Please provide a reason why you would like to change your trainer.",
    myschedule_rechedule_next_info:
      "For further information regarding the rescheduling and cancellation options of trainer please visit our",
    myschedule_rechedule_next_faq: "FAQ portal.",
    myschedule_rechedule_next_noShow: "Don't show this info page again",
    myschedule_rechedule_next_done: "Done",
    myschedule_rechedule_skipButton: "Skip",
    myschedule_upcoming_joinNow: "Join now",
    myschedule_cancel_question: "Are you sure you want to cancel this session?",
    myschedule_cancel_button: "Cancel Session",
    myschedule_cancel_no: "No",
    myschedule_invalid_session: "There are no sessions for this course.",
    myschedule_sessionDuraion_minutes: "Minutes",
    myschedule_homepage_view: "View",
    myschedule_reschedule_button: "Reschedule",
    myschedule_addToCalendar_instr1: "Click on the",
    myschedule_addToCalendar_instr2:
      "download button to get your Learnship schedule. You can then add it to your personal calendar.",
    myschedule_addToCalendar_instr3:
      "If you have previously added a Learnship schedule to your calendar, please make sure to delete the existing one first.",
    myschedule_addToCalendar_instr4: "Learn more about how to add the Learnship schedule to your personal calendar",
    myschedule_addToCalendar_instr5: "here",
    myschedule_no_teacher_title: "Teacher not assigned",
    myschedule_no_teacher_body:
      "No Sessions can be added at the moment (No teachers assigned). Please contact coach@globalenglish.com to continue with your program.",
    myschedule_status_lost: "Lost",
    myschedule_status_finished: "Finished",
    myschedule_status_completed: "Completed",
    myschedule_status_cancelled: "Cancelled",
    myschedule_status_inprogress: "In progress",
    myschedule_status_pending: "Pending",
    myschedule_status_active: "Active",
    myschedule_status_inplanning: "In planning",

    // my schedule page translations end
    // Progress page
    progress_title: "My Progress",
    progress_activity_report: "Activity report",
    progress_test_results: "Test results",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Reach Skills",
    progress_skill_note:
      "You must complete 70% or more of the coursework and sessions to be eligible for a certificate of completion.",
    progress_overall_card_title_prework: "Pre-work completed",
    progress_overall_card_title_homework: "Homework completed",
    progress_overall_card_title_session: "Session completed",
    progress_overall_card_title_certificate: "Certificate",
    progress_overall_card_title_skillsCompleted: "Skills completed",
    progress_overall_card_title_badgesEarned: "Badges earned",
    progress_overall_card_title_missionsPassed: "Missions passed",
    progress_overall_card_title_timeInReach: "Time in Reach (HH:MM)",
    progress_noSubskill: "There is no subskill to show.",
    progress_tab_nodata: "No data to show here.",
    progress_percentCompleted: "percent completed",
    progress_subskill_preworkTitle: "Pre-Work",
    progress_subskill_homeworkTitle: "Homework",
    progress_subskill_sessionTitle: "Session",
    progress_subskill_sessionStatusCompleted: "Completed",
    progress_subskill_sessionStatusNotCompleted: "Not completed",
    progress_subskill_sessionStatusAbsent: "Absent",
    progress_subskill_sessionStatusUpcoming: "Upcoming",
    progress_subskill_sessionStatusScheduled: "Scheduled",
    progress_subskill_sessionStatusScheduling: "Scheduling",
    progress_subskill_sessionStatusNoSessions: "No sessions",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Total time",
    progress_activity_tooltip_activitiesCompleted: "Activities completed",
    progress_activity_tooltip_reachMissionsCompleted: "Reach missions completed",
    progress_activity_tooltip_timeinhhmm: "Time in HH:MM",
    progress_activity_tabDaily: "Daily",
    progress_activity_tabWeekly: "Weekly",
    progress_activity_tabMonthly: "Monthly",
    progress_activity_tabQuarterly: "Quarterly",
    progress_activity_tabQuarter: "Quarter",
    progress_activity_tabYearly: "Yearly",
    progress_acitivity_Minutes: "Minutes",
    progress_acitivity_legend_selfpaced: "Self Paced Learning Time",
    progress_acitivity_legend_trainerLed: "Trainer Led Time",
    progress_acitivity_legend_recommended: "Recommended",
    progress_testresults_table_testname: "Test name",
    progress_testresults_table_scores: "Scores",
    progress_testresults_table_date: "Date",
    progress_testresults_info: "Your tests results will appear in 24 hours",
    progress_inprogress: "In progress",
    progress_totalscore: "Total score",
    progress_placedText: "Placed",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "Part",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_badge_dialog_box_title:
      "In order to earn a certificate of completion, we require completion of 70% of the digital exercises.",
    progress_badge_dialog_box_golden: "A success score of 80% earns a gold badge",
    progress_badge_dialog_box_silver: "A success score between 70% and 79% earns a silver badge",
    progress_badge_dialog_box_bronze: "A success score between 50% to 69% earns a bronze badge",
    progerss_badge_dailog_box_digitalActivities:
      "The success score is calculated based on your performance and engagement with the online digital activities",
    progress_badge_dailog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with the online digital activities and live sessions",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",

    //EO Progress page
    // Email templates start
    wcTitle: "Writing Center",
    guidelines: "Writing Guidelines",
    sampleDocs: "Sample Documents",
    wcGroup1: "Apologies",
    wcGroup2: "Complaints",
    wcGroup3: "Compliments",
    wcGroup4: "Congratulations",
    wcGroup5: "Documents",
    wcGroup6: "Invitations",
    wcGroup7: "Job Applications",
    wcGroup8: "Marketing and Sales",
    wcGroup9: "Meetings",
    wcGroup10: "Notices",
    wcGroup11: "Orders",
    wcGroup12: "Pricing Information",
    wcGroup13: "Requests",
    wcGroup14: "Thank You",
    wcTitle11: "Apology for a Delay in a Project",
    wcTitle12: "Apology for an Account Error",
    wcTitle13: "Apology for a Late Shipment",
    wcTitle14: "Apology for Delivery of Damaged Goods",
    wcTitle15: "Apology for Missing a Meeting",
    wcTitle21: "General Complaint",
    wcTitle22: "Complaint about a Problem with a Product",
    wcTitle23: "Complaint about an Overcharge to an Account",
    wcTitle31: "Compliment to a Colleague on a Project",
    wcTitle32: "Compliment about Customer Service",
    wcTitle33: "Compliment about a Product",
    wcTitle41: "Congratulations on a Promotion (Formal)",
    wcTitle42: "Congratulations on a Promotion (Informal)",
    wcTitle43: "Congratulations on a Personal Event",
    wcTitle51: "Requested Document",
    wcTitle52: "Order Form or Purchase Order",
    wcTitle53: "Invoice",
    wcTitle61: "Invitation to a Social Event",
    wcTitle62: "Invitation to a Business Event",
    wcTitle63: "Accepting an Invitation",
    wcTitle64: "Declining an Invitation",
    wcTitle65: "Canceling a Business Event",
    wcTitle71: "Acknowledgement of Receipt of Application",
    wcTitle81: "Announcement of a New Product",
    wcTitle82: "Announcement of a New Area Representative",
    wcTitle83: "New Product Demo",
    wcTitle84: "Change of Billing Address",
    wcTitle85: "Follow-Up after a First Sales Meeting",
    wcTitle86: "New Customer Welcome",
    wcTitle87: "Holiday Message to Stockholders or Customers",
    wcTitle91: "Proposing a Time for a Meeting",
    wcTitle92: "Confirming a Meeting",
    wcTitle93: "Postponing a Meeting",
    wcTitle94: "Canceling a Meeting",
    wcTitle95: "Summarizing a Meeting",
    wcTitle101: "Suspended Account",
    wcTitle102: "Request to Close an Account",
    wcTitle111: "Confirming an Order",
    wcTitle112: "Providing Shipping Confirmation",
    wcTitle113: "Canceling an Order",
    wcTitle114: "Changing an Order",
    wcTitle115: "Acknowledging a Delivery",
    wcTitle121: "Providing Pricing Information",
    wcTitle122: "Accepting a Price Quotation",
    wcTitle123: "Rejecting a Price Quotation",
    wcTitle131: "Request for Clarification of Information",
    wcTitle132: "Request for Information about a Product",
    wcTitle133: "Request for Information about a Service",
    wcTitle141: "General Thanks",
    guideGroup1: "Common Writing Problems",
    guideGroup2: "General Business Communication",
    guideGroup3: "Business Documents",
    guideTitle11: "Reasons for Unclear Writing",
    guideTitle12: "Basic Writing Errors",
    guideTitle13: "Problems with Verbs",
    guideTitle21: "Directness in Business Communication",
    guideTitle22: "Language for Sales and Marketing",
    guideTitle23: "Everyday Business Idioms",
    guideTitle31: "Effective Emails",
    guideTitle32: "Presentations: General Tips",
    guideTitle33: "Presentations: Effective Openings",
    backIndex: "Back to Index",
    copyText: "Copy Text",
    exportEmail: "Export Text to Email",
    Blob:
      "Email templates cover a wide variety of business topics. Select the template you want and export it directly to your email client where you can edit it.",
    OpenInEmail: "Open in email",
    Quote1: "There are currently 3.3 billion email accounts in the world.",
    Quote1By: "Mashable",
    Quote2: "Email generates nearly a 2X return compared to other channels.",
    Quote2By: "Direct Marketing Lead",
    Quote3: "3.5 million emails are sent per second.",
    Quote3By: "Marketing Lead",
    SelectACategory: "Select a category",
    WatchTutorial: "Watch a video tutorial",
    String: "Quote1",
    NoAm: "North America",
    Cenam: "Central America",
    SoAm: "남미",
    EUR: "유럽",
    ASIA: "아시아",
    CenASIA: "Central Asia",
    SoEASIA: "South East Asia",
    MidEAST: "Middle East",
    AFR: "아프리카",
    AUST: "호주",
    Cana: "캐나다",
    Mexi: "멕시코",
    Uniteds: "미국",
    CostaR: "Costa Rica",
    DomRep: "Dominican Republic",
    Guate: "Guatemala",
    Jama: "Jamaica",
    Panam: "Panama",
    TriniTob: "Trinidad & Tobago",
    Arge: "아르헨티나",
    Braz: "브라질",
    Chil: "칠레",
    Vene: "베네수엘라",
    Colomb: "Colombia",
    Peru: "Peru",
    Urug: "Uruguay",
    Austria: "Austria",
    Belg: "벨기에",
    Bulg: "Bulgaria",
    Croatia: "Croatia",
    Czec: "체코 공화국",
    Denm: "덴마크",
    Finl: "핀란드",
    Fran: "프랑스",
    Germ: "독일",
    Greec: "Greece",
    Hung: "헝가리",
    Icel: "Iceland",
    Irel: "아일랜드",
    Ital: "이태리",
    Lith: "Lithuania",
    Luxem: "Luxembourg",
    Neth: "네덜란드",
    Norw: "노르웨이",
    Pola: "폴란드",
    Port: "Portugal",
    Roma: "루마니아",
    Russ: "러시아연방",
    Serb: "Serbia",
    Slovakia: "Slovakia",
    Slovania: "Slovenia",
    Spai: "스페인",
    Swed: "스웨덴",
    Swit: "스위스",
    Turk: "터키",
    Ukra: "우크라이나",
    Unitedk: "영국",
    Chin: "중국",
    Hong: "홍콩",
    Indi: "인도",
    Japa: "일본",
    Mongo: "Mongolia",
    Pakis: "Pakistan",
    SoKore: "South Korea",
    SriLan: "Sri Lanka",
    Taiw: "대만",
    Afgh: "Afghanistan",
    Azer: "Azerbaijan",
    Kaza: "카자흐스탄",
    Camb: "Cambodia",
    Indo: "인도네시아",
    Malay: "말레이시아",
    Phil: "필리핀",
    Sing: "싱가포르",
    Thai: "태국",
    Viet: "Vietnam",
    Bah: "Bahrain",
    Iran: "Iran",
    Iraq: "Iraq",
    Isra: "이스라엘",
    Jor: "Jordan",
    Kuw: "Kuwait",
    Leb: "Lebanon",
    Oma: "Oman",
    Qat: "Qatar",
    SauArb: "Saudi Arabia",
    UAE: "United Arab Emirates",
    Alger: "Algeria",
    Angol: "Angola",
    Egyp: "이집트",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenya",
    Malaw: "Malawi",
    Moroc: "Morocco",
    Mozam: "Mozambique",
    Nige: "나이지리아",
    SoAfr: "South Africa",
    Tanz: "Tanzania",
    Ugan: "Uganda",
    Zamb: "Zambia",
    Austra: "호주",
    NewZea: "New Zealand",
    culturenotes_mainintrotext:
      "Familiarize yourself with the cultures of the regions that are important to your business and professional life.",
    culturenotes_useculturalinfo:
      "Use our cultural information to prepare for important meetings with customers and coworkers around the world.",
    culturenotes_topicfamiliarize:
      "Familiarize yourself with customs, such as business hours, dining out, gift giving, etc. in other cultures.",
    culturenotes_topiclearnculture:
      "Learn about cultural practices, cultural differences, and local manners to avoid making cultural mistakes.",
    culturenotes_tmaworldtext:
      "Country reports are developed by our partner TMA World and are available in downloadable PDF versions.",
    culturenoteslocation_viewbytopic: "View by topic",
    culturenoteslocation_viewbycountry: "View by country",
    culurecenter_disclaimer_title: "고지사항",
    culturecenter_disclaimer:
      "당신이 읽을 정보가 당신을 새로운 문화에 익숙해지도록 만들어줄 출발점 이자 길잡이로 여기십시오. 이 도구는 당신이 사람들의 행동, 태도 및 반응을 분석하고 더 잘 이해하기 위한 기본지식을 제공하며 또한 일반적인 문화 패턴에 대해 배우는 데에도 도움을 줄 것입니다. 그러나 특정 문화의 공통된 특성은 지역 및 개인의 성격에 따라 다르다는 점을 염두 하는 것이 중요합니다.",
    culturecenter_intercept_title: "문화센터가 돌아왔습니다!​​",
    culturecenter_intercept_text1: "약간의 수정을 거쳐 문화센터가 다시 돌아왔음을 알리게 되어 기쁩니다!",
    culturecenter_intercept_text2:
      "문화센터를 통해 미국, 캐나다, 멕시코, 중국, 일본, 인도 등 전 세계 20개국의 문화와 관습에 대해 자세히 알아볼 수 있습니다.​",
    culturecenter_intercept_direct: "문화센터 바로가기​",
    dailyNewsFeed_resources: "Resources",
    dailyNewsFeed_daily_News: "Daily news feed",
    dailyNewsFeed_newsfeedoftheday: "News feed of the day",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Sorry, we are unable to fetch your daily news feed, please try again after sometime.",
    dailyNewsFeed_viewMoreCategories: "View more categories",
    // Email templates end
    //Error Page Translations
    error_not_found: "Oops! Page not found.",
    error_contact_csm: "Please contact your Customer Success Manager for help.",
    error_under: "Under",
    error_maintenance: "maintenance",
    error_under_maintenance: "Our site is currently undergoing scheduled maintenance.",
    error_inconvenience: "We're sorry for any inconvenience.",
    error_tryagain: "Please try again later.",
    error_tryagainMins: "Please try again in",
    error_minutes: "minute(s).",
    error_hours: "hour(s)",
    error_oops: "Oops!",
    error_permission_denied: "You don't have permission to view this page!",
    error_link_home: "home page",
    error_contact_admin: "Please contact your Learnship Administrator for help.",
    error_sorry: "We're Sorry.",
    error_load: "There was a problem loading this page.",
    error_clear_cache: "Please clear your browser's cache, check your internet connection, and try again.",
    error_contact: "Please contact our",
    error_contact_cst: "customer support team",
    error_forhelp: "for help.",
    error_having_trouble: "Still having trouble?",
    //Accents and Dialects Dropdowns
    AF: "아프리카",
    AS: "아시아",
    AU: "오스트레일리아-오세아니아",
    CA: "카리브 해",
    CE: "중앙아메리카",
    EU: "유럽",
    MI: "중동",
    NO: "북미",
    SO: "남미",
    CAMER: "카메룬",
    EGYPT: "이집트",
    ETHIO: "에티오피아",
    GHANA: "가나",
    GUINE: "기니",
    NIGER: "나이지리아",
    SOUTH: "남아프리카",
    TANZA: "탄자니아",
    AFGHA: "아프가니스탄",
    CHINA: "중국",
    INDIA: "인도",
    INDON: "인도네시아",
    JAPAN: "일본",
    KAZAK: "카자흐스탄",
    LEBAN: "레바논",
    MONGO: "몽골",
    NORTH: "북베트남",
    PAKIS: "파키스탄",
    PHILI: "필리핀",
    SINGA: "싱가포르",
    KOREA: "한국",
    SRI_L: "스리랑카",
    TAIWA: "대만",
    THAIL: "태국",
    TURKM: "투르크메니스탄",
    AUSTR: "호주",
    FIJI_: "피지",
    NEW_Z: "뉴질랜드",
    BERMU: "버뮤다",
    CUBA_: "쿠바",
    HAITI: "아이티",
    COSTA: "코스타리카",
    GUATE: "과테말라",
    MARTI: "마르티니크 (프랑스)",
    TRINI: "트리니다드 토바고",
    AUSTRI: "오스트리아",
    BELAR: "벨로루시",
    BELGI: "벨기에",
    BULGA: "불가리아",
    CYPRU: "키프로스",
    CZECH: "체코 공화국",
    DENMA: "덴마크",
    ENGLA: "영국",
    FINLA: "핀란드",
    FRANC: "프랑스",
    GEORG: "그루지야",
    GERMA: "독일",
    GREEC: "그리스-헬라스",
    HUNGA: "헝가리",
    IRELA: "아일랜드",
    ITALY: "이태리",
    MACED: "마케도니아",
    NETHE: "네덜란드",
    NORTHI: "북아일랜드",
    POLAN: "폴란드",
    ROMAN: "루마니아",
    RUSSI: "러시아연방",
    SCOTL: "스코틀랜드",
    SPAIN: "스페인",
    SWEDE: "스웨덴",
    SWITZ: "스웨덴",
    TURKE: "터키",
    UKRAI: "우크라이나",
    WALES: "웨일스",
    IRAN_: "이란",
    IRAQ_: "이라크",
    ISRAE: "이스라엘",
    KUWAI: "쿠웨이트",
    SAUDI: "사우디아라비아",
    SYRIA: "시리아",
    CANAD: "캐나다",
    MEXIC: "멕시코",
    ARGEN: "아르헨티나",
    BRAZI: "브라질",
    CHILE: "칠레",
    COLOM: "콜롬비아",
    PARAG: "파라과이",
    PERU_: "페루",
    VENEZ: "베네수엘라",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "영어의 악센트와 방언",
    US: "미합중국",
    ALABA: "앨라배마",
    ALASK: "알래스카",
    ARKAN: "아칸소",
    CALIF: "캘리포니아",
    FLORI: "플로리다",
    GEORG_US: "조지아",
    HAWAI: "하와이",
    ILLIN: "일리노이",
    INDIA_US: "인디애나",
    KANSA: "캔자스",
    KENTU: "켄터키",
    LOUIS: "루이지애나",
    MAINE: "메인",
    MARYL: "메릴랜드",
    MASSA: "매사추세츠",
    MICHI: "미시간",
    MINNE: "미네소타",
    MISSI: "미시시피",
    MISSO: "미주리",
    MONTA: "몬태나",
    NEBRA: "네브래스카",
    NEW_H: "뉴햄프셔",
    NEW_J: "뉴저지",
    NEW_Y: "뉴욕",
    NCARO: "노스캐롤라이나",
    NDAKO: "노스다코타",
    OHIO_: "오하이오",
    OKLAH: "오클라호마",
    PENNS: "펜실베이니아",
    SOUTH_US: "사우스캐롤라이나",
    TENNE: "테네시",
    TEXAS: "텍사스",
    VIRGI: "버지니아",
    WEST_: "웨스트버지니아",
    WISCO: "위스콘신",
    manager_email_managertext:
      "Your company has requested a monthly report for your manager indicating your progress in Learnship. Please provide your manager’s email address below.",
    // survey and notification
    notification_description_plural: "{days} days remaining to complete the survey. You must complete it by {date}.",
    notification_description_singular: "1 day remaining to complete the survey. You must complete it by {date}.",
    notification_maintenance_message: "Halo will be undergoing scheduled maintenance on {date} at {time}.",
    //renewal
    renewal_welcome: "Welcome back to Learnship!",
    renewal_text:
      "Your Learnship license will expire on {date}. To continue improving your Business English Communication skills, renew your license today. Your study plan and all of your work will be saved and you will continue at your current level.",
    renewal_later: "Please ask me later",
    renewal_affirmative: "YES, I want to renew my license.",
    renewal_negative: "NO, I do not want to renew my license.",
    renewal_yes: "YES",
    renewal_no: "NO",
    courselevel: "Course level",
    currentunit: "Current unit",
    upcomingsession: "Upcoming session",
    viewschedule: "View Schedule",
    currentskills: "Skills",
    currentsubskills: "Sub-skills",

    // TWT translations
    twt_talk_with_teacher_title: "교사 주관 대화방",
    twt_sub_heading: "온라인 수업에서 선생님과 다른 학습자들과 함께 회화 실력을 키우십시오!",
    twt_select_sessions: "세션을 선택하십시오",
    twt_view_schedule_title: "일정보기 및 캘린더에  추가",
    twt_next_week: "다음 주",
    twt_previous_week: "이전 주",
    twt_add_to_calendar: "캘린더에 추가",
    twt_view_more: "좀 더 보기",
    twt_topic: "주제",
    twt_session_unavailable: "No sessions available",
    twt_level_unassigned: "Sorry you will need a level to view this page, please try after sometime or return to home.",
    twt_joining_session: "Joining",
    twt_select_language: "Select language",
    twt_limit_message: "이번 주에 이미 수업 하나를 수강하셨습니다.",
    twt_class_policy: "수업 방침",
    twt_class_policy_title: "교사 주관 대화방 정책 및 지침",
    twt_class_policy_subHeading:
      "교사 주관 대화방 사용이 교육적이고 즐거운 이용을 위해 다음 정책과 지침이 중요합니다. 주의 깊게 읽어 주십시오.",
    twt_class_policy_list01:
      "주 1회 수업에 *참석할 수 있습니다. 수업 참여자는 8명으로 제한됩니다. 모범 사례 : 수업 시작 전 교사 주관 대화방 페이지에 접속하십시오.  각 세션은 수업 시작 후 10분 동안만 참여를 허용합니다. 예를 들어, 9시에 시작하는 세션은 9시10분까지 수업에 참여를 할 수 있습니다. 처음 10분이 지나면 세션에 참여할 수 없습니다. 라이선스 유형(제한된 사용 또는 무제한 사용)에 따라 세션 참여 횟수는 다를 수 있습니다",
    twt_class_policy_list02_sub1: "강의실에 입장할 때 대화 상자에 이름, 도시, 국가 및 학습 레벨을 입력하십시오.",
    twt_class_policy_list02_sub2: `예를 들어, "My name is Leo, and I'm from Sao Paulo, Brazil. I'm in Level 6."`,
    twt_class_policy_list02_sub3: `예를 들어, "제 이름은 레오이고 브라질 상파울루에서 왔어요. 레벨 6입니다."`,
    twt_class_policy_list03:
      "기술적 문제가 있는 경우 <b>고객지원부에</b> 문의하십시오. 서면으로 문제를 제출하려면 페이지 상단의 도움말을 클릭하거나 Learnship One 페이지의  <b>채팅 도구</b>를 사용하여 고객지원 담당자에게 문의하십시오. 교사에게 기술적 도움을 요청하지 마십시오.",
    twt_class_policy_list04:
      "초급, 중급, 고급 및 모든 레벨의 4가지 세션 레벨이 있습니다. 자신의 영어 실력에 적합한 세션에 참여하십시오. 예를 들어, 학습 레벨 0-3인 경우 초급 세션 또는 모든 레벨 세션에 참여할 수 있습니다. 영어 실력에 적합하지 않은 세션에 참여한 경우,  교사는 학습자에게 적합하지 않은 세션에 참여했음을 알릴 것입니다. 이 경우 두 가지 옵션이 있습니다. 계속해서 세션에 참여하고 싶은 경우 강사에게 듣기로( 말하기를 할 수 없습니다)수업에 참여 함을 알리는 것입니다.  다른 하나는 세션에서 나와 다른 적합한 세션에 참여하는 것입니다.",
    twt_class_policy_list05:
      "말하기 없이 온라인 세션을 듣고 싶다면 일주일에 한 시간 이용할 수 있습니다. 이후, 말하기로 세션에 참여해야 합니다. 일 년에 총 4회 듣기로 세션에 참여할 수 있습니다. 이 제한을 초과하여 말하기로 세션에 참여 않으면 세션이 종료됩니다",
    twt_class_policy_list06:
      "우리는 영어 또는 다른 언어로 외설적이거나 모욕적인 언어를 용납하지 않을 것입니다. 이 정책을 위반 즉시 세션에서 사용자를 삭제합니다. 우리는 관리자에게 당신의 공격 행동에 대해 통보하며 귀하의 계정을 해지할 수 있습니다",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "다른 장치에서 세션에 참여 중입니다. 현재 기기에서 수업 참여 전 다른 장치에서 로그 아웃하십시오.",
    twt_max_capacity_error_message:
      "죄송합니다. 최대 인원 사용중으로 세션에 참여할 수 없습니다. 다른 세션에 참여하십시오.",
    twt_notification_message: "There's a conversation session starting right now. Do you want to join?",
  },
};
